import { DeliveryAddress } from "../model/delivery-address";
import { apiSlice } from "../stores/base/api-slice";

const deliveryAddressEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getDeliveryAddress: builder.query<Array<DeliveryAddress>, void>({
			providesTags: ["DeliveryAddress"],
			query: () => ({
				url: "/delivery-address",
				method: "GET",
			}),
		}),
		createDeliveryAddress: builder.mutation<string, DeliveryAddress>({
			invalidatesTags: ["DeliveryAddress"],
			query: data => ({
				url: "/delivery-address",
				method: "POST",
				body: data,
			}),
		}),
		updateDeliveryAddress: builder.mutation<string, DeliveryAddress>({
			invalidatesTags: ["DeliveryAddress"],
			query: data => ({
				url: "/delivery-address",
				method: "PUT",
				body: data,
			}),
		}),
		deleteDeliveryAddress: builder.mutation<void, string>({
			invalidatesTags: ["DeliveryAddress"],
			query: id => ({
				url: "/delivery-address",
				method: "DELETE",
				body: {
					deliveryAddressId: id,
				},
			}),
		}),
	}),
});

export const { useLazyGetDeliveryAddressQuery, useCreateDeliveryAddressMutation, useUpdateDeliveryAddressMutation, useDeleteDeliveryAddressMutation } =
	deliveryAddressEndpoints;
